import { generateTestId } from "@client-shared";

export const setFinanceInvoicesViewTestId = (identifier: string): string =>
  generateTestId("FinanceInvoicesView", identifier);

// Container
export const setFinanceInvoicesViewContainerTestId = (): string =>
  setFinanceInvoicesViewTestId("container");

// Header elements
export const setFinanceInvoicesViewTitleTestId = (): string =>
  setFinanceInvoicesViewTestId("title");
export const setFinanceInvoicesViewInvoiceCountTestId = (): string =>
  setFinanceInvoicesViewTestId("invoice-count");
export const setFinanceInvoicesViewExportCsvButtonTestId = (): string =>
  setFinanceInvoicesViewTestId("export-csv-button");
